export const fetchWithAuth = async (
  url: string,
  filename: string,
  openInNewTab = false
) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    throw new Error("Usuário não autenticado");
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Não autorizado para acessar o documento");
  }

  const blob = await response.blob();
  const fileURL = window.URL.createObjectURL(blob);

  if (openInNewTab) {
    window.open(fileURL, "_blank");
  } else {
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = filename || "documento";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  window.URL.revokeObjectURL(fileURL);
};
